import { render, staticRenderFns } from "./MenuDisabled.vue?vue&type=template&id=3bd60e3b&scoped=true&"
import script from "./MenuDisabled.vue?vue&type=script&lang=js&"
export * from "./MenuDisabled.vue?vue&type=script&lang=js&"
import style0 from "./MenuDisabled.vue?vue&type=style&index=0&id=3bd60e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd60e3b",
  null
  
)

export default component.exports